import {h} from 'ui/Framework';

export default h('svg', {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '-1 -1 16 15',
  height: '14',
  width: '15'
}, [
  h('path', {
    d: 'M11.91 14l-4.55-2.391L2.811 14l.87-5.065L0 5.348l5.086-.74L7.36 0l2.275 4.609 5.085.739-3.68 3.587z'
  })
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/star.es6.js